/**
 * Section Navigation Scroll Behavior
 * Shows/hides sticky nav based on grid visibility
 * Optimized for performance and smooth transitions
 */

(function () {
    'use strict';

    // Check for IntersectionObserver support
    if (!('IntersectionObserver' in window)) {
        return;
    }

    // Get all section navigation instances
    const sectionNavs = document.querySelectorAll('[data-section-nav]');

    if (!sectionNavs.length) {
        return;
    }

    sectionNavs.forEach(section => {
        const stickyNav = section.querySelector('[data-sticky-nav]');
        const grid = section.querySelector('.section-nav-grid');

        // Find the hero section (previous sibling of section nav)
        const hero = section.previousElementSibling;

        if (!stickyNav || !grid) {
            return;
        }

        // Track current state to prevent unnecessary DOM updates
        let isSticky = false;

        // If we have a hero element, observe it instead of the grid
        // This gives a clearer trigger point - when hero scrolls out of view
        const observeTarget = hero && hero.classList.contains('interior-hero') ? hero : grid;

        // Intersection Observer to detect when hero/grid leaves viewport
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                // Show sticky nav when observed element is out of view
                const shouldBeSticky = !entry.isIntersecting;

                // Only update if state actually changed
                if (shouldBeSticky !== isSticky) {
                    isSticky = shouldBeSticky;

                    if (isSticky) {
                        // Element is out of view, show sticky nav
                        stickyNav.classList.add('visible');
                    } else {
                        // Element is in view, hide sticky nav
                        stickyNav.classList.remove('visible');
                    }
                }
            });
        }, {
            threshold: 0, // Trigger when element is completely out of view
            rootMargin: '0px 0px 0px 0px'
        });

        // Observe the hero (if available) or fall back to grid
        observer.observe(observeTarget);

        // Handle active state for anchor links (same-page navigation)
        const navLinks = section.querySelectorAll('[data-nav-link]');
        navLinks.forEach(link => {
            link.addEventListener('click', function (e) {
                const href = this.getAttribute('href');

                // Only handle anchor links on the same page
                if (href && href.startsWith('#')) {
                    // Remove active class from all links in this section
                    navLinks.forEach(l => l.classList.remove('active'));
                    // Add active class to clicked link
                    this.classList.add('active');
                }
            });
        });
    });

})();
